import { getCandidateGroups, addCandidatesToGroup } from '../../../../services/popupApi';

export const api = {
  getOptions: async (field) => {
    if (field.fetchOptionsKey === 'candidateGroups') return getCandidateGroups();
    return [];
  },
  // Use cached dynamicOptions (already fetched by getOptions above) — no double fetch
  submit: async (values, _context, { dynamicOptions }) => {
    const groups = dynamicOptions['groupId'] ?? [];
    const selectedGroup = groups.find((g) => String(g.value) === String(values.groupId));
    await addCandidatesToGroup({
      candidateIds: _context.selectedIds,
      groupId: values.groupId,
      groupName: selectedGroup?.label ?? '',
    });
  },
};
